/**
 * ISO-8601 timestamp schema. All MQTT envelopes carry `ts` per docs/CONTRACTS.md §MQTT.
 */
import { z } from 'zod';
export const Iso8601Schema = z.string().datetime({ offset: true });
//# sourceMappingURL=timestamp.js.map